import { createFileRoute } from '@tanstack/react-router'

import { UserGroupDetailsLearnpaths } from '@/user-groups/components/UserGroupDetails/UserGroupDetailsLearnpaths/UserGroupDetailsLearnpaths'

export const Route = createFileRoute(
  '/company/_management/groups/$groupId/learnpaths',
)({
  component: UserGroupDetailsLearnpaths,
})
